import { IImage } from './i-image';

export interface ISearchFacetResponse {
  filters: ISearchFacetResponseFilter[];
  categories: ISearchFacetResponseCategory[];
  suppliers: ISearchFacetResponseSupplier[];
  brands: ISearchFacetResponseBrand[];
}

export interface ISearchFacetResponseCategory {
  id: string;
  name: string;
  children: ISearchFacetResponseCategory[] | null;
}

export interface ISearchFacetResponseFilter {
  key: string;
  options: ISearchFacetResponseFilterOption[];
}

export interface ISearchFacetResponseFilterOption {
  value: string;
  total: number;
}

export interface ISearchFacetResponseSupplier {
  id: string;
  tradingName: string;
  type: string;
  sector: string;
  images: IImage[];
}

export interface ISearchFacetResponseBrand {
  id: string;
  name: string;
  images: IImage[];
}
